export default "__VITE_ASSET__BdhPLMFx__"